import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPut } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_DELETE_EMPLOYER_BY_ID, KEY_DELETE_EMPLOYER_BY_ID } from '../constants';
import { MOCK_RESPONSE_DELETE_EMPLOYER_BY_ID } from '../mocks';

type GenericDeleteEmployerById = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY
>;

type RequestDeleteEmployerById = GenericDeleteEmployerById['request']['body'] &
  GenericDeleteEmployerById['request']['path'];

export type CallParamsDeleteEmployerById = Omit<RequestDeleteEmployerById, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseDeleteEmployerById = GenericDeleteEmployerById['response']['body'];

type CallErrorDeleteEmployerById = GenericApiError;

type CallSelectorsDeleteEmployerById = unknown;

export const deleteEmployerByIdCall = createGeneralCall<
  CallParamsDeleteEmployerById,
  CallResponseDeleteEmployerById,
  CallErrorDeleteEmployerById,
  CallSelectorsDeleteEmployerById
>({
  id: KEY_DELETE_EMPLOYER_BY_ID,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_DELETE_EMPLOYER_BY_ID(org as unknown as string, payload.employeeId);
    },
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
        employeeId: undefined,
      };
    },
  method: 'delete',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_DELETE_EMPLOYER_BY_ID : undefined,
});
